import React from "react";
import ApprovedBadge from "./badges/ApprovedBadge";
import FilesBadge from "./badges/FilesBadge";
import PendingBadge from "./badges/PendingBadge";
import UnseenMessagesBadge from "./badges/UnseenMessagesBadge";
import BrandIcon from "../../components/BrandIcon";
import { routes } from "utilities/routing/generatedRoutes";
import LinkedShowLines from "components/LinkedShows/LinkedShowElement";
interface Props {
  item: server.dto.AdvancingProvideListItem
}

const AdvancingProvideRowCard = (props: Props) => {
  const { item } = props;

  const onClick = () => {
    window.location.href = routes.advancing_InvitationLanding(item.secret).absolute;
  };

  return <div className="hoverable advancing-list-row" onClick={onClick}>
    <div className="grow1 flex gap">
      <div>
        <BrandIcon name={item.client.name} iconUrl={item.client.iconUrl} />
      </div>

      <div className="flex-column gap-small">
        <LinkedShowLines
          dateTime={item.show.dateTime}
          eventDescription={item.show.eventDescription}
          venueDescription={item.show.venueDescription}
          format="big" />
        <div className="s1_gray">{item.client.name}</div>
      </div>
    </div>
    <div className="flex gap advancing-badges">
      <PendingBadge amountPendingResponses={item.itemsApprovalPendingCount} />
      <FilesBadge filesCount={item.filesCount} />
      <ApprovedBadge amountApprovedResponses={item.itemsApprovedCount} />
      <UnseenMessagesBadge amountUnseenMesssages={item.unreadMessageCount} />
    </div>
  </div>;
};

export default AdvancingProvideRowCard;